import { useCallback, useEffect, useRef, useState } from 'react';

export function useDebounceEventCntHandler<Event>(
  handler: (event: Event) => void,
  delay: number = 250,
  expectedEventCnt: number = 1,
) {
  const eventsCountRef = useRef(0);
  const [event, setEvent] = useState<Event>();
  const timeoutRef = useRef<NodeJS.Timeout>(undefined);

  useEffect(() => {
    if (!timeoutRef.current) {
      timeoutRef.current = setTimeout(() => {
        if (eventsCountRef.current === expectedEventCnt && event) {
          handler(event);
        }
        eventsCountRef.current = 0;
        setEvent(undefined);
      }, delay);
    }
    eventsCountRef.current++;
    return () => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = undefined;
    };
  }, [delay, handler, event, expectedEventCnt]);
  return useCallback((event: Event) => {
    setEvent(_ => event);
  }, []);
}
